export default __webpack_public_path__ + "ab06bf22ebe2b4c64d332741324fc5bb.png";